import { createAsyncThunk } from '@reduxjs/toolkit';

import { readRegistrationPrefill } from '@/modules/auth/api/prefill';
import { getCitiesForOnboarding } from '@/modules/common/store/selectors';
import { IPartner } from '@/modules/partner/model';
import {
  getEmptyPartner,
  LANDING_CITY_ID_KEY,
  pickEmptyPartnerCity,
} from '@/modules/partner/model/getEmptyPartner';
import { namespace } from '@/modules/partner/namespace';
import { getUserData, selectIsNew } from '@/modules/user/store/selectors';
import { RootState } from '@/root-store';
import { queryParamsService } from '@/services/queryParams';

import { setPartner } from '../actions';

const setEmptyPartner = createAsyncThunk(
  `${namespace}/set-empty-partner`,
  async (_, { dispatch, getState }): Promise<IPartner> => {
    const state = getState() as RootState;
    const me = getUserData(state);
    const isNew = selectIsNew(state);

    // Core never learns the email of a V3 registration; the mediator held it
    // for this very load. Asked only for a brand-new user - anyone else has a
    // record of their own, and its email is the truth.
    const prefill = isNew ? await readRegistrationPrefill() : undefined;

    // Seeded here rather than in the Welcome form, so everything that reads
    // the partner's city — the region, its links and permissions — agrees with
    // the form from the first render.
    const emptyPartner = getEmptyPartner(me, {
      city: pickEmptyPartnerCity({
        isNew,
        user: me,
        // Consumed, not just read: it belongs to this registration alone.
        landingCityId: queryParamsService.consumeSingleByName(LANDING_CITY_ID_KEY),
        cities: getCitiesForOnboarding(state),
      }),
      email: prefill?.email,
    });

    dispatch(setPartner(emptyPartner));

    return emptyPartner;
  },
);

export { setEmptyPartner };
